<script>
import Layout from '@layouts/main'
// import { parseOptionsMethods } from '@state/helpers'
import ParseOptionsRow from '@components/parse-options-row'
import CdmFieldsRow from '@components/cdm-fields-row'
import RevUsageFieldRow from '@components/rev-usage-field-row'
import draggable from 'vuedraggable'
import {
  cdmFieldsMethods,
  roleMethods,

  // Upload imports
  cdmMethods,
  authComputed,
  cdmrMethods,
} from '@state/helpers'
import _ from 'lodash'

export default {
  metaInfo: {
    title: 'Settings',
    meta: [{ name: 'description', content: 'Settings' }],
  },
  components: {
    Layout,
    ParseOptionsRow,
    CdmFieldsRow,
    draggable,
    RevUsageFieldRow,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    revUsageFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      updateOrderError: null,
      formError: null,
      editedIndex: -1,
      isWorking: false,
      roleItems: [],
      searchingRoles: false,
      roleSearchError: null,
      roleSearch: null,
      selectedRole: null,
      cdmFields: this.fields,
      revFields: this.revUsageFields,
      editedItem: {
        roleId: null,
        order: 0,
      },
      defaultItem: {
        roleId: null,
        order: 0,
      },

      // Upload data
      uploadError: null,
      tryingToUpload: false,
      totalData: 0,
    }
  },
  computed: {
    // Upload computed
    ...authComputed,

    // !TODO: Working? Necessary? //
    // userCanCreateCdmr() {
    //   for (var i = 0; i < this.approvalWorkflows.length; i++) {
    //     var aw = this.approvalWorkflows[i]

    //     for (var n = 0; n < aw.role.userRoles.length; n++) {
    //       var ur = aw.role.userRoles[n]
    //       if (ur.userId === this.currentUser.id) {
    //         return true
    //       }
    //     }
    //   }

    //   return false
    // },
  },
  watch: {
    cdmFields: {
      handler() {
        this.updateItemOrder()
      },
    },
    revFields: {
      handler() {
        this.updateRevItemOrder()
      },
    },
    roleSearch: {
      handler() {
        this.searchRoles()
      },
    },
  },
  created() {
    this.updateItemOrder = _.debounce(this.updateItemOrder, 500)
    this.updateRevItemOrder = _.debounce(this.updateRevItemOrder, 500)
    this.searchRoles = _.debounce(this.searchRoles, 500)
  },
  methods: {
    // Upload imports
    ...cdmMethods,
    ...cdmrMethods,

    ...cdmFieldsMethods,
    ...roleMethods,
    updateItemOrder() {
      var order = {}
      this.updateOrderError = null
      for (var i = 0; i < this.cdmFields.length; i++) {
        var field = this.cdmFields[i]
        field.order = i

        order[field.id] = i
      }

      return this.updateFieldOrder(order)
        .then(response => {})
        .catch(error => {
          this.updateOrderError = error
        })
    },
    updateRevItemOrder() {
      var order = {}
      this.updateOrderError = null
      for (var i = 0; i < this.revFields.length; i++) {
        var field = this.revFields[i]
        field.order = i

        order[field.id] = i
      }

      return this.updateRevFieldOrder(order)
        .then(response => {})
        .catch(error => {
          this.updateOrderError = error
        })
    },
    searchRoles() {
      this.roleSearchError = null
      this.getRolesWithoutWorkflow({ search: this.roleSearch })
        .then(response => {
          this.roleItems = response.results
        })
        .catch(error => {
          this.roleSearchError = error
        })
    },

    // Upload methods
    updateSelectedFile(event) {
      if (event.target.files.length > 0) {
        this.file = event.target.files[0]
      } else {
        this.file = null
      }
    },
    submitFile() {
      if (!this.file) {
        return
      }

      this.tryingToUpload = true
      this.uploadError = null

      return this.uploadCdms({ file: this.file })
        .then(data => {
          window.location.reload()
        })
        .catch(error => {
          this.tryingToUpload = false
          this.uploadError = error
        })
    },
    submitRevUsage() {
      if (!this.file) {
        return
      }

      this.tryingToUpload = true
      this.uploadError = null

      return this.uploadRevUsage({ file: this.file })
        .then(data => {
          window.location.reload()
        })
        .catch(error => {
          this.tryingToUpload = false
          this.uploadError = error
        })
    },
    tryAddCdmr() {
      this.isWorking = true
      this.createError = null

      return this.cdmrAdd()
        .then(result => {
          this.isWorking = false

          this.$router.push({
            name: 'editCdmr',
            params: { cdmrId: result.id },
          })
        })
        .catch(error => {
          this.isWorking = false
          this.createError = error
          this.$swal(
            'Error',
            typeof error === 'string'
              ? error
              : 'An error occurred creating this CDM-R',
            'error'
          )
        })
    },
  },
}
</script>

<template>
  <Layout>
    <!-- NEW -->
    <v-container fluid grid-list-md ma-0>
      <!-- Header -->
      <v-layout row align-center justify-space-between>
        <h3>Configurations</h3>

        <!-- !TODO: Working? Necessary -->
        <!-- <BaseButton
          v-if="userCanCreateCdmr"
          :disabled="isWorking"
          @click="tryAddCdmr"
        >
          <BaseIcon v-if="isWorking" name="sync" spin />
          <span v-else>Add CDM</span>
        </BaseButton>-->

        <!-- <div v-if="currentUserCanImportFiles && !totalData">
          <span>No CDMs - Import your first file</span> <br />
        </div>-->

        <div v-if="currentUserCanImportFiles">
          <label>
            Upload New File
            <input
              id="file"
              ref="file"
              type="file"
              @change="updateSelectedFile"
            />
          </label>
          <br />
          <br />
          <BaseButton :disabled="tryingToUpload" @click="submitFile">
            <BaseIcon v-if="tryingToUpload" name="sync" spin />
            <span v-else>Upload as CDM</span> </BaseButton
          >&nbsp;
          <BaseButton :disabled="tryingToUpload" @click="submitRevUsage">
            <BaseIcon v-if="tryingToUpload" name="sync" spin />
            <span v-else>Upload as Revenue Usage</span>
          </BaseButton>
          <p v-if="uploadError">
            There was an error uploading your file. Check your CDM Parse
            Options.
          </p>
        </div>
      </v-layout>

      <!-- Tabs -->
      <v-tabs color="transparent" slider-color="cyan">
        <v-tab>Parse Options</v-tab>
        <v-tab-item :class="$style.tabItem">
          <v-flex>
            <v-card>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col" colspan="2">File Type</th>
                    <th scope="col" colspan="2">Delimiter</th>
                    <th scope="col" colspan="2">Ignore Quotes</th>
                    <th scope="col" colspan="2">Trim</th>
                  </tr>
                </thead>
                <tbody>
                  <ParseOptionsRow
                    v-for="option in options"
                    :key="option.id"
                    :parse-option="option"
                  ></ParseOptionsRow>
                </tbody>
              </table>
              <span v-if="!options.length">No Parse Options</span>
            </v-card>
          </v-flex>
        </v-tab-item>

        <v-tab>CDM Fields</v-tab>
        <v-tab-item :class="$style.tabItem">
          <v-flex>
            <v-card>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th colspan="1"></th>
                    <th colspan="2">Column</th>
                    <th colspan="2">Caption</th>
                    <th colspan="1">CDM ID</th>
                    <th colspan="1">Active Flag</th>
                    <th colspan="1">Show in CDM</th>
                    <th colspan="1">Include in CDMR</th>
                    <th colspan="1">Is Procedure Code</th>
                    <th colspan="1">Is Modifier</th>
                    <th colspan="1">Is Revenue Code</th>
                    <th colspan="2">Data Type</th>
                    <th colspan="2">Data Format</th>
                  </tr>
                </thead>
                <draggable
                  v-model="cdmFields"
                  element="tbody"
                  @start="drag = true"
                  @end="drag = false"
                >
                  <CdmFieldsRow
                    v-for="field in cdmFields"
                    :key="field.id"
                    :field="field"
                  ></CdmFieldsRow>
                </draggable>
              </table>
              <span v-if="!cdmFields.length">No Fields</span>
            </v-card>
          </v-flex>
        </v-tab-item>

        <v-tab>Rev Usage Fields</v-tab>
        <v-tab-item :class="$style.tabItem">
          <v-flex>
            <v-card>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th colspan="1"></th>
                    <th colspan="2">Column</th>
                    <th colspan="1">References CDM</th>
                    <th colspan="2">Caption</th>
                    <th colspan="1">Show in table</th>
                    <th colspan="1">Aggregate</th>
                    <th colspan="2">Data Type</th>
                    <th colspan="2">Data Format</th>
                  </tr>
                </thead>
                <draggable
                  v-model="revFields"
                  element="tbody"
                  @start="drag = true"
                  @end="drag = false"
                >
                  <RevUsageFieldRow
                    v-for="field in revFields"
                    :key="field.id"
                    :field="field"
                  ></RevUsageFieldRow>
                </draggable>
              </table>
              <span v-if="!revFields.length">No Fields</span>
            </v-card>
          </v-flex>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.tabItem {
  padding-top: 25px;
  border-top: 1px solid gainsboro;
}
</style>
